/**
 * Remove empty query strings and unknown category slugs from URL params.
 * Returns { params, changed }.
 *
 * Slug validity is decided by the caller (server-side), not by scanning a
 * loaded category list — that list is paginated, so a valid slug on a later
 * page would look unknown and get stripped from the URL.
 */
export function sanitizeSearchParams(searchString, { categoryInvalid = false } = {}) {
  const params = new URLSearchParams(searchString);
  let changed = false;

  const query = params.get('query');
  if (query !== null && !query.trim()) {
    params.delete('query');
    changed = true;
  }

  const category = params.get('Category');
  if (category && categoryInvalid) {
    params.delete('Category');
    changed = true;
  }

  return { params, changed };
}

export function searchParamsToString(params) {
  const str = params.toString();
  return str ? `?${str}` : '';
}
